import { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { addTemplate } from '../../controller';
import { requestHandler } from '../../helper';
import ErrorFilter from '../../helper/errorFilter';
import SingleError from '../../helper/SingleError';
import { UserValidateFields } from '../validate/userValidation';
import TempModal from './info/TemplateModal';

function TemplateAdd({ getAllTemplateData, categoryData }) {

    const [showTemp, setShowTemp] = useState(false);

    const handleCloseTemp = () => setShowTemp(false);
    const handleShowTemp = () => setShowTemp(true);
    const requireField = ["name", "categoryId", "pdf", "docx", "pptx"];
    const requiredUrls = ["pdf", "docx", "pptx", "xlsx"];
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
        setFileUrls({ pdf: '', docx: '', pptx: '', xlsx: '' });
        setTemplateName('');
        setIsSample(false);
        setErrors({});
    }
    const handleShow = () => setShow(true);
    const [submitCount, setSubmitCount] = useState(0);
    const [errors, setErrors] = useState({});

    // Instead of file state, store URLs
    const [fileUrls, setFileUrls] = useState({ pdf: '', docx: '', pptx: '', xlsx: '' });
    const [templateName, setTemplateName] = useState('');
    const [categoryId, setCategoryId] = useState([]);
    const [isSample, setIsSample] = useState(false);

    const [isAll, setIsAll] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);

    // Handle URL input change
    const handleUrlInputChange = (event, type) => {
        const url = event.target.value;
        setFileUrls(prevFiles => ({ ...prevFiles, [type]: url }));
        let validationErrors = UserValidateFields({
            ...fileUrls, [type]: url, name: templateName, categoryId: isAll ? [] : categoryId,
            isSample: isSample,
        });

        validationErrors = ErrorFilter(validationErrors, requiredUrls,);
        // Check if there's an error for the current type (pdf, docx, pptx)
        if (!validationErrors[type]) {
            const { [type]: removedError, ...remainingErrors } = errors;
            setErrors(remainingErrors);
        } else {
            setErrors(validationErrors);
        }
    };


    const handleChange = async (e) => {
        const { name, value, checked, type } = e.target;
        let newValue = type === "checkbox" ? checked : value;
        const data = {
            name: templateName,
            categoryId: isAll ? [] : categoryId,
        };
        if (submitCount > 0) {
            let validationErrors = UserValidateFields({
                ...data,
                [name]: newValue
            });

            // Filter validation errors based on required fields
            validationErrors = ErrorFilter(validationErrors, requireField);
            setErrors(validationErrors);

            // Clear specific error if no errors exist for that field
            if (Object.keys(validationErrors).length === 0) {
                delete errors[name];
            }
        }

        // Update the state with the new value
        if (name === "templateName") {
            setTemplateName(newValue);
        } else if (name === "categoryId") {
            setCategoryId(newValue);
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            name: templateName,
            categoryId: isAll ? [] : categoryId,
            isSample: isSample,
            pdf: fileUrls.pdf,
            docx: fileUrls.docx,
            pptx: fileUrls.pptx,
            xlsx: fileUrls.xlsx,
            status: true
        };

        setSubmitCount(prevCount => prevCount + 1);
        const updatedValues = { ...data };
        let validationErrors = UserValidateFields(updatedValues);

        validationErrors = ErrorFilter(validationErrors, requireField);
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length === 0) {
            // Send the data in the body of the request (not using FormData)
            await requestHandler(
                () => addTemplate(data),  // Directly pass the data object here
                null,
                (res) => {
                    toast.success(res.message);
                    handleClose();
                    setFileUrls({ pdf: '', docx: '', pptx: '', xlsx: '' });
                    setTemplateName('');
                    setCategoryId([]);
                    setSelectedCategory(null);
                    getAllTemplateData();
                    setIsAll(false);
                },
                () => { }
            );
        }
    };

    const handleSampleToggle = (sampleStatus) => {
        setIsSample(sampleStatus);
        delete errors.isSample; // Clear the error if exists
        setErrors({ ...errors });
    };


    return (
        <>
            <button className='add-btn' onClick={handleShow}>
                <img src="../images/png/plush.png" width={12} height={12} alt="" />
                <p className='m-0'>Add</p>
            </button>

            <Modal className='modal-main' scrollable show={show} centered size='md' onHide={handleClose}>
                <Modal.Body>
                    <Modal.Title>
                        <div className="row justify-content-center">
                            <div className="col-11 col-8">
                                <h2>Add Template</h2>
                            </div>
                        </div>
                    </Modal.Title>
                    <div className='modal-form'>
                        <Form>
                            {/* URL Inputs for Files */}
                            {['pdf', 'docx', 'pptx', 'xlsx'].map((type) => (
                                <Form.Group className="mb-3" key={type}>
                                    <Form.Label>{`Add ${type.toUpperCase()} URL`}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={`Enter ${type.toUpperCase()} URL`}
                                        value={fileUrls[type] || ''}
                                        onChange={(event) => handleUrlInputChange(event, type)}
                                    />
                                    <SingleError error={errors?.[type]} />
                                </Form.Group>
                            ))}

                            {/* Template Name Input */}
                            <Form.Group className="mb-3">
                                <Form.Label>Template Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Template Name"
                                    value={templateName}
                                    onChange={handleChange}
                                    name="templateName"
                                    required
                                />
                                <SingleError error={errors?.name} />
                            </Form.Group>

                            {/* Is Sample Toggle */}
                            <Form.Group className="mb-3" controlId="formGroupPassword">
                                <Form.Label>Is Sample</Form.Label>
                                <Dropdown className='status-btn'>
                                    <Dropdown.Toggle id="dropdown-basic">
                                        {isSample ? 'Yes' : 'No'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => handleSampleToggle(false)}>No</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleSampleToggle(true)}>Yes</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Form.Group>

                            {/* Category Selection */}
                            <Form.Group className="mb-3">
                                <Form.Label>Category</Form.Label>
                                <Dropdown className='status-btn'>
                                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                                        {isAll ? 'All' : selectedCategory || 'Select Category'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {/* <Dropdown.Item onClick={() => {
                                            setIsAll(true);
                                            setCategoryId([]);
                                            setSelectedCategory(null);
                                        }}>
                                            All
                                        </Dropdown.Item> */}
                                        {categoryData.map((category, index) => (
                                            <Dropdown.Item
                                                key={index}
                                                onClick={() => {
                                                    setIsAll(false);
                                                    setCategoryId([category._id]);
                                                    setSelectedCategory(category.name);
                                                    delete errors.categoryId;
                                                    setErrors({ ...errors });
                                                }}
                                            >
                                                {category.name}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                                <SingleError error={errors?.categoryId} />
                            </Form.Group>

                            <div className='d-md-flex align-items-center gap-3 mt-4'>
                                <button className='cancel-btn' onClick={handleClose} type='button'>Cancel</button>
                                <button className='save-btn' type='button' onClick={handleSubmit} >Save</button>
                            </div>
                            <div className='d-flex align-items-center justify-content-center gap-1 mt-4 cursor-pointer' onClick={handleShowTemp}>
                                How to Upload?
                                <img src="/images/svg/info.svg" width={20} alt="" />
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>

            <TempModal show={showTemp} handleClose={handleCloseTemp} />
        </>
    );
}

export default TemplateAdd;
